import type { RatingChip } from "@/lib/feedback/ratingTypes";

/**
 * Fixed reason vocabulary for a thumbs-DOWN on a free tool/result surface
 * (kundali, matching, calculators, dosha checkers). Used with
 * `RatingPrompt mode="thumbs+reasons"`.
 *
 * Why a fixed list, not free text: a bare thumbs-down is a number; a thumbs-down
 * with a reason is a measurable theme. Chips also complete far more often than a
 * free-text box. The chip LABEL is submitted as feedback text (so
 * tag_feedback_themes.py keyword-codes it into context.themes[]) and the chip id
 * lands in context.reasons[], so both the human label and the structured tag are
 * queryable in v_qual_human_daily / v_qual_feedback_themes_daily.
 *
 * Labels are intentionally worded to match the theme taxonomy keywords
 * (business/ishvaram/data/cx/feedback_themes.yaml) — "wrong" → chart_accuracy,
 * "more detail" → (wanted_more), "understand" → confusing.
 */
export const RESULT_REASONS: RatingChip[] = [
  { id: "inaccurate", label: "Result seems wrong" },
  { id: "confusing", label: "Hard to understand" },
  { id: "wanted_more", label: "Wanted more detail" },
  { id: "unexpected", label: "Not what I expected" },
];

/** Matching adds a score-specific reason; everything else uses RESULT_REASONS. */
export const MATCH_REASONS: RatingChip[] = [
  { id: "score_wrong", label: "Score seems wrong" },
  { id: "confusing", label: "Hard to understand" },
  { id: "wanted_remedies", label: "Wanted remedies" },
  { id: "unexpected", label: "Not what I expected" },
];
